import Cookies from 'js-cookie';
import cookie from 'cookie';
export default (function (context, inject) {
  var plugin = {
    get isApp() {
      var _context$req, _context$req$headers;
      // return true

      var layout;
      if (process.server && (_context$req = context.req) !== null && _context$req !== void 0 && (_context$req$headers = _context$req.headers) !== null && _context$req$headers !== void 0 && _context$req$headers.cookie) {
        layout = cookie.parse(context.req.headers.cookie)['ovatu.layout'];
      } else if (process.client) {
        layout = Cookies.get('ovatu.layout');
      }
      return layout === 'app';
    },
    navigate: function navigate(url) {
      var _window$OvatuApp;
      (_window$OvatuApp = window.OvatuApp) === null || _window$OvatuApp === void 0 ? void 0 : _window$OvatuApp.postMessage(JSON.stringify({
        type: 'navigate',
        url: url
      }));
    }
  };
  inject('app', plugin);
});